/**
 * Doorway icons — peach stroke draw + light-pen highlight when in view.
 * Animations pause off-screen and only run one cycle at a time with a gap.
 */

(function () {
  var SELECTOR = '[data-doorway-icon]';
  var DRAWN = 'is-drawn';
  var ACTIVE = 'is-animating';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setAnimating(icon, on) {
    icon.classList.toggle(ACTIVE, on);
  }

  function observe(icons) {
    if (!icons.length) return;

    if (prefersReducedMotion()) {
      icons.forEach(function (icon) {
        icon.classList.add(DRAWN);
        setAnimating(icon, false);
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      icons.forEach(function (icon) {
        icon.classList.add(DRAWN);
        setAnimating(icon, true);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var icon = entry.target;
          if (entry.isIntersecting) {
            if (!icon.classList.contains(DRAWN)) {
              var delay = Number(icon.dataset.doorwayIconDelay) || 0;
              window.setTimeout(function () {
                // Only start if still on screen
                if (icon.dataset.doorwayIconVisible !== '1') return;
                icon.classList.add(DRAWN);
                setAnimating(icon, true);
              }, delay);
            } else {
              setAnimating(icon, true);
            }
            icon.dataset.doorwayIconVisible = '1';
          } else {
            icon.dataset.doorwayIconVisible = '0';
            setAnimating(icon, false);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -5% 0px' }
    );

    icons.forEach(function (icon, index) {
      icon.dataset.doorwayIconDelay = String(Math.min(index * 160, 480));
      icon.dataset.doorwayIconVisible = '0';
      observer.observe(icon);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    observe(Array.prototype.slice.call(scope.querySelectorAll(SELECTOR)));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('visibilitychange', function () {
    var on = document.visibilityState === 'visible';
    document.querySelectorAll(SELECTOR + '.' + DRAWN).forEach(function (icon) {
      if (!on) {
        setAnimating(icon, false);
        return;
      }
      if (icon.dataset.doorwayIconVisible === '1') {
        setAnimating(icon, true);
      }
    });
  });
})();
